module.exports = __webpack_public_path__ + "img/fy6.7b4afcfa.jpg";